module.exports = __webpack_public_path__ + "img/nudo.a038e4b4.jpg";